var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaxpinu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_83_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9556 17.9046V23.3335H27.8667V19.8024L26.4122 23.3335H25.5878L24.1256 19.8024V23.3335H23.0367V17.9046H24.2733L26 21.9413L27.7267 17.9046H28.9556ZM33.7499 22.2991H31.5877L31.2299 23.3335H30.0866L32.0388 17.8968H33.3066L35.2588 23.3335H34.1077L33.7499 22.2991ZM33.4543 21.4279L32.6688 19.1568L31.8832 21.4279H33.4543ZM39.6285 23.3335L38.454 21.5057L37.3885 23.3335H36.1596L37.8707 20.5957L36.1363 17.9046H37.3885L38.5629 19.7246L39.6207 17.9046H40.8496L39.1463 20.6346L40.8807 23.3335H39.6285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9556 17.9046V23.3335H27.8667V19.8024L26.4122 23.3335H25.5878L24.1256 19.8024V23.3335H23.0367V17.9046H24.2733L26 21.9413L27.7267 17.9046H28.9556ZM33.7499 22.2991H31.5877L31.2299 23.3335H30.0866L32.0388 17.8968H33.3066L35.2588 23.3335H34.1077L33.7499 22.2991ZM33.4543 21.4279L32.6688 19.1568L31.8832 21.4279H33.4543ZM39.6285 23.3335L38.454 21.5057L37.3885 23.3335H36.1596L37.8707 20.5957L36.1363 17.9046H37.3885L38.5629 19.7246L39.6207 17.9046H40.8496L39.1463 20.6346L40.8807 23.3335H39.6285Z",
    fill: "url(#paint0_linear_83_105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8926 27.9181C26.8926 28.2085 26.8226 28.4807 26.6826 28.7348C26.5478 28.9888 26.3326 29.1937 26.037 29.3492C25.7467 29.5048 25.3785 29.5825 24.9326 29.5825H24.0226V31.667H22.9337V26.2381H24.9326C25.3526 26.2381 25.7104 26.3107 26.0059 26.4559C26.3015 26.6011 26.5218 26.8007 26.667 27.0548C26.8174 27.3088 26.8926 27.5966 26.8926 27.9181ZM24.8859 28.7037C25.1867 28.7037 25.4096 28.6363 25.5548 28.5014C25.7 28.3614 25.7726 28.167 25.7726 27.9181C25.7726 27.3892 25.477 27.1248 24.8859 27.1248H24.0226V28.7037H24.8859ZM29.1435 26.2381V31.667H28.0546V26.2381H29.1435ZM35.2515 31.667H34.1626L31.6971 27.9414V31.667H30.6082V26.2303H31.6971L34.1626 29.9637V26.2303H35.2515V31.667ZM37.7898 26.2381V29.5981C37.7898 29.9663 37.8857 30.2488 38.0776 30.4459C38.2694 30.6377 38.5391 30.7337 38.8865 30.7337C39.2391 30.7337 39.5113 30.6377 39.7031 30.4459C39.895 30.2488 39.9909 29.9663 39.9909 29.5981V26.2381H41.0876V29.5903C41.0876 30.0518 40.9865 30.4433 40.7842 30.7648C40.5872 31.0811 40.3202 31.3196 39.9831 31.4803C39.6513 31.6411 39.2805 31.7214 38.8709 31.7214C38.4665 31.7214 38.0983 31.6411 37.7665 31.4803C37.4398 31.3196 37.1805 31.0811 36.9887 30.7648C36.7968 30.4433 36.7009 30.0518 36.7009 29.5903V26.2381H37.7898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8926 27.9181C26.8926 28.2085 26.8226 28.4807 26.6826 28.7348C26.5478 28.9888 26.3326 29.1937 26.037 29.3492C25.7467 29.5048 25.3785 29.5825 24.9326 29.5825H24.0226V31.667H22.9337V26.2381H24.9326C25.3526 26.2381 25.7104 26.3107 26.0059 26.4559C26.3015 26.6011 26.5218 26.8007 26.667 27.0548C26.8174 27.3088 26.8926 27.5966 26.8926 27.9181ZM24.8859 28.7037C25.1867 28.7037 25.4096 28.6363 25.5548 28.5014C25.7 28.3614 25.7726 28.167 25.7726 27.9181C25.7726 27.3892 25.477 27.1248 24.8859 27.1248H24.0226V28.7037H24.8859ZM29.1435 26.2381V31.667H28.0546V26.2381H29.1435ZM35.2515 31.667H34.1626L31.6971 27.9414V31.667H30.6082V26.2303H31.6971L34.1626 29.9637V26.2303H35.2515V31.667ZM37.7898 26.2381V29.5981C37.7898 29.9663 37.8857 30.2488 38.0776 30.4459C38.2694 30.6377 38.5391 30.7337 38.8865 30.7337C39.2391 30.7337 39.5113 30.6377 39.7031 30.4459C39.895 30.2488 39.9909 29.9663 39.9909 29.5981V26.2381H41.0876V29.5903C41.0876 30.0518 40.9865 30.4433 40.7842 30.7648C40.5872 31.0811 40.3202 31.3196 39.9831 31.4803C39.6513 31.6411 39.2805 31.7214 38.8709 31.7214C38.4665 31.7214 38.0983 31.6411 37.7665 31.4803C37.4398 31.3196 37.1805 31.0811 36.9887 30.7648C36.7968 30.4433 36.7009 30.0518 36.7009 29.5903V26.2381H37.7898Z",
    fill: "url(#paint1_linear_83_105)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_83_105",
    x: 0,
    y: -8.6665,
    width: 64,
    height: 67.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654817 0 0 0 0 0.249288 0 0 0 0 0.720833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_83_105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_83_105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_105",
    x1: 45.5018,
    y1: 48.0006,
    x2: 50.0886,
    y2: 25.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#4F30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_105",
    x1: 19.4999,
    y1: 40.5007,
    x2: 41.228,
    y2: 44.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#4F30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00F8E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxpinu);
export default __webpack_public_path__ + "static/media/maxpinu.834d9a38a3aefc7541be9a8b452b4801.svg";
export { ForwardRef as ReactComponent };